import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserDetailsComponent } from './pages/user-details/containers/user-details.component';
import { UserDetailsModule } from './pages/user-details/containers/user-details.module';
import { QuoteCalculationComponent } from './pages/quote-calculation/containers/quote-calculation.component';
import { QuoteCalculationModule } from './pages/quote-calculation/containers/quote-calculation.module';
import { MedicalUnderwritingModule } from './pages/medical-underwriting/medical-underwriting.module';
import { CMSResolver } from './core/resolvers/cms.resolver';
import { HealthResolver } from './core/resolvers/healthAndLifestyle.resolver';
import { AuthGuardService } from './pages/user-details/components/auth/auth-guard-service';
import { MedicalUnderwritingComponent } from './pages/medical-underwriting/container/medical-underwriting.component';
import { TestUIModule } from './pages/test-ui-components/test.module';
import { TestUIComponent } from './pages/test-ui-components/container/test-ui-component';
// tslint:disable-next-line:max-line-length
import { ActivitiesOfDailyLivingComponent } from './pages/medical-underwriting/components/activities-of-daily-living/activities-of-daily-living.component';
//import { QuestionaryResolver } from './core/resolvers/questionary.resolver';
import { AfterApplyComponent } from 'src/app/pages/after-apply/containers/after-apply.component';
import { AfterApplyModule } from 'src/app/pages/after-apply';
// tslint:disable-next-line: max-line-length
import { HoMedicalUnderwrittingComponent } from './pages/medical-underwriting/container/HO/ho-medical-underwritting/ho-medical-underwritting.component';
import { uiCompJsonResolver } from 'src/app/shared/services/api-services/ui.comp.json.resolver';
// import { configDataResolver } from 'src/app/shared/services/api-services/config-data.json.resolver';

export function userModuleGetter() {
  return UserDetailsModule;
}
export function quoteModuleGetter() {
  return QuoteCalculationModule;
}
export function medicalModuleGetter() {
  return MedicalUnderwritingModule;
}
export function testModuleGetter() {
  return TestUIModule;
}
export function afterApplyModuleGetter() {
  return AfterApplyModule ;
}
export const appRoute: Routes = [

  // { path: '', redirectTo: 'user', pathMatch: 'full' },
  {
    path: '',
    component: UserDetailsComponent,
    children: [
      // { path: 'create', loadChildren: './pages/user-details/containers/user-details.module#CasesModule' }
      // { path: 'list', component: ListUserComponent }
      { path: '', redirectTo: 'home', pathMatch: 'full',
       },
      { path: 'home', loadChildren: userModuleGetter }
      // { path: 'user', loadChildren: './pages/user-details/containers/user-details.module#UserDetailsModule' }
    ],
    resolve: { contentData: CMSResolver, uiCompJson: uiCompJsonResolver}
  },
  {
    path: '',
    component: QuoteCalculationComponent,
    children: [

      // { path: 'create', loadChildren: './page QuestionaryResolvers/user-details/containers/user-details.module#CasesModule' }
      // { path: 'list', component: ListUserComponent }
      { path: '', redirectTo: 'quote', pathMatch: 'full' },
      { path: 'quote', loadChildren: quoteModuleGetter }
      // { path: 'user', loadChildren: './pages/user-details/containers/user-details.module#UserDetailsModule' }
    ],
    resolve: { contentData: CMSResolver }
  },
  {
    path: '',
    component: MedicalUnderwritingComponent,
    children: [
      { path: '', redirectTo: 'medical', pathMatch: 'full' },
      { path: 'home', loadChildren: medicalModuleGetter }
  ],
    resolve: { healthData: HealthResolver, contentData: CMSResolver}
  },
  {
    path: '',
    component: HoMedicalUnderwrittingComponent,
    children: [
      { path: '', redirectTo: 'ho-underwriting', pathMatch: 'full' },
      { path: 'ho-underwriting', loadChildren: medicalModuleGetter }
  ],
    resolve: { healthData: HealthResolver, contentData: CMSResolver}
  },

  {
    path: '',
    component: TestUIComponent,
    children: [
      { path: '', redirectTo: 'test', pathMatch: 'full' },
      { path: 'test', loadChildren:  testModuleGetter}
  ],
    resolve: { healthData: HealthResolver, contentData: CMSResolver}
  },
  {
    path: '',
    component: AfterApplyComponent,
    children: [
      
      { path: '', redirectTo: 'apply', pathMatch: 'full',
       },
      { path: 'apply', loadChildren: afterApplyModuleGetter }
      // { path: 'user', loadChildren: './pages/user-details/containers/user-details.module#UserDetailsModule' }
    ],
    resolve: { contentData: CMSResolver }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoute,
    {
      enableTracing: false,
      useHash: true,
      scrollPositionRestoration: 'top',
      paramsInheritanceStrategy: 'always'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
